module.exports = __webpack_public_path__ + "images/interior-3d-3-406730636ac834c8dde102abd3968bc4.jpg";